// extracted by mini-css-extract-plugin
module.exports = {"main":"table-row_main__2GVxm","flexrow":"table-row_flexrow__mnu11","mobilelabel":"table-row_mobilelabel__3P8er"};